// La requete des personnes mentionnables et les identifiants ARIA de leur liste
// (feat-feedback-les-mentions-de-personnes). Hors de MentionList.tsx : un fichier de composants
// n exporte que des composants (react-refresh/only-export-components).
import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';
import type { MentionableDto } from '../schemas';

/**
 * Les personnes proposees apres « @ » : celles qui voient deja le ticket, servies par le serveur
 * (aucune liste devinee au client). La requete ne vit que dans MentionPicker, monte seulement
 * pendant une mention : le fil sans mention n en fait aucune. Une erreur (route absente, plafond
 * atteint) laisse simplement la liste vide.
 */
export function useMentionables(ticketId: string, saisie: string | null) {
  return useQuery({
    queryKey: ['feedback', 'mentionables', ticketId, saisie],
    queryFn: () =>
      api.get<MentionableDto[]>(
        `/api/feedback/${ticketId}/mentionables?q=${encodeURIComponent(saisie ?? '')}`,
      ),
    enabled: saisie !== null,
    staleTime: 30_000,
    retry: false,
  });
}

export const MENTION_LIST_ID = 'feedback-mention-list';

export function mentionOptionId(index: number): string {
  return `${MENTION_LIST_ID}-${index}`;
}
